import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({});
  const [targetDate] = useState(new Date('2025-12-31T23:59:59'));

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Countdown Timer
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Time until New Year 2026
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h3" component="div" color="primary">
              {timeLeft.days || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Days
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h3" component="div" color="primary">
              {timeLeft.hours || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Hours
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h3" component="div" color="primary">
              {timeLeft.minutes || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Minutes
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h3" component="div" color="primary">
              {timeLeft.seconds || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Seconds
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Countdown;